import React from 'react';

import { EventButton, RefreshBar } from '~/components/ContractReturns/Returns.styled';
import { useReturnsRefresh } from '~/components/ContractReturns/useReturnsRefresh';

type ReturnsRefreshButtonProps = {
  action: Parameters<typeof useReturnsRefresh>[0];
  payload: Record<string, unknown>;
  contractId: string | number;
};

/**
 * Botão "Atualizar" da aba de Retornos: recarrega apenas os dados de retornos
 * do contrato, com loading/cooldown e tratamento de erro centralizados no hook.
 */
export function ReturnsRefreshButton({ action, payload, contractId }: Readonly<ReturnsRefreshButtonProps>) {
  const { refresh, loading, disabled } = useReturnsRefresh(action, payload, contractId);

  return (
    <RefreshBar>
      <EventButton icon="Refresh" title="Atualizar" onClick={refresh} loading={loading} disabled={disabled} />
    </RefreshBar>
  );
}
